import React from 'react';

import NextImage from '../common/NextImage';
import { getScoreColor, uniqueId } from '../../utils/generalLiveCenter';

const GolfRoundTable = ({ data, name, fid }) => {
  const baseURL =
    process.env.REACT_APP_BASE_URL ??
    "https://ipublisher-microservices.6lgx.com";

  return (
    <div className="global_table golf_round_table">
      <table>
        <thead>
          <tr>
            <th></th>
            <th>Hole</th>
            <th>1</th>
            <th>2</th>
            <th>3</th>
            <th>4</th>
            <th>5</th>
            <th>6</th>
            <th>7</th>
            <th>8</th>
            <th>9</th>
            <th>10</th>
            <th>11</th>
            <th>12</th>
            <th>13</th>
            <th>14</th>
            <th>15</th>
            <th>16</th>
            <th>17</th>
            <th>18</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td></td>
            <td>Par</td>
            {data?.map((par, index) => (
              <td key={par?.par + par?.pts + index}>{par?.par || '-'}</td>
            ))}
          </tr>
          <tr>
            <td>
              <div className="player_name_wrp">
                <div className="flag_img">
                  <NextImage src={`${baseURL}/public/assets/images/flags/country_${fid}.png`} width={32} height={32} />
                </div>
                <span className="cr_name">{name}</span>
              </div>
            </td>
            <td>Score</td>
            {data?.map((pts, index) => (
              <td key={uniqueId(index)}>
                <span className={`round_num ${getScoreColor(pts?.pts || 0, pts?.par || 0)}`}>{pts?.pts || '-'}</span>
              </td>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default GolfRoundTable;
